import { DiscountType } from "@daytrip/legacy-enums";
import { Expose } from "class-transformer";
import { IsDefined, IsEnum, IsInt, IsNumber, IsOptional, IsString, IsUUID } from "class-validator";
import { v4 as uuid } from "uuid";

import { GField, GObjectType } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";

@CDEntity("discounts")
@GObjectType("Discount")
export class Discount extends CDBaseEntity {
    @CDObjectIdColumn()
    @GField()
    @IsUUID()
    @Expose()
    public _id: string = uuid();

    @CDColumn()
    @GField()
    @IsInt()
    @IsDefined()
    @Expose()
    public price: number = 0;

    @CDColumn()
    @GField()
    @IsInt()
    @IsDefined()
    @Expose()
    public fee: number = 0;

    @CDColumn()
    @Expose()
    @IsOptional()
    @IsEnum(DiscountType)
    public type?: DiscountType;

    @CDColumn()
    @IsString()
    @IsDefined()
    @Expose()
    public description: string = "";

    @CDColumn()
    @GField()
    @IsNumber()
    @IsOptional()
    @Expose()
    public priceDiscountCoefficient?: number;

    @CDColumn()
    @GField()
    @IsNumber()
    @IsOptional()
    @Expose()
    public feeDiscountCoefficient?: number;
}
